<template>
  <div class="mb-12">
    <hr class="w-px bg-n-gray border border-n-gray w-full mt-12 mb-12" />
    <div class="flex flex-col md:flex-row">
      <div class="w-full md:w-1/4">
        <h2 class="text-2.5xl font-sans-bold text-n-gray-dark font-hairline mb-6">
          Events
        </h2>
      </div>
      <div class="w-full md:w-3/4 mb-6 md:mb-0" v-if="showCreatePastEventButtons">
        <div class="flex flex-col md:flex-row justify-end">
          <router-link :to="{ name: 'event-create' }" class="button button__medium flex-auto md:flex-initial">
            Create new event
          </router-link>
          <div class="ml-0 md:ml-3 mb-3 md:mb-0" />
          <router-link :to="{ name: 'past-event-list' }" class="button button-secondary button__medium flex-auto md:flex-initial">
            See past events
          </router-link>
        </div>
      </div>
    </div>
    <div>
      <template v-if="!user.action_flags.has_read_event_guide">
        <div class="text-n-gray-dark text-2xl font-hairline">
          As a new member of our community, please read <button class="underline" @click="modalOpen = true">our brief guide</button>
          before creating your first event.
        </div>
        <div class="mt-6">
          <button class="button button__medium" @click="modalOpen = true" style="width: 320px">
            Read our event guide
          </button>
        </div>
      </template>
      <template v-else-if="hasCurrentEvents">
        <div class="pl-5 flex flex-wrap">
          <div v-for="(event, i) in events" :key="event.id" class="w-full md:w-1/3">
            <div :class="cardContainerClasses(i)" class="pb-6">
              <event-card :_event="event" />
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="hasCurrentOrPastEvents">
        <div class="text-n-gray-dark text-2xl font-hairline">
          You have no upcoming events.
        </div>
      </template>
      <template v-else>
        <div class="text-n-gray-dark text-2xl font-hairline">
          Create your first virtual or in-person event to engage our shared community.
        </div>
        <div class="mt-6">
          <router-link :to="{ name: 'event-create' }" class="button button__medium flex-auto md:flex-initial" style="width: 320px">
            CREATE YOUR FIRST EVENT!
          </router-link>
        </div>
      </template>
    </div>
    <EventGuideModal v-model="modalOpen" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NewTabA11y from "../../global/a11y/NewTabA11y.vue";
import DashboardEventItem from "../../dashboard/DashboardEventItem.vue";
import EventGuideModal from "./event/modals/EventGuideModal.vue";
import EventCard from "./event/EventCard.vue";

export default {
  name: "EventsHome",
  components: {EventCard, EventGuideModal, DashboardEventItem, NewTabA11y },
  computed: {
    ...mapGetters({ user: 'user', events: "events", }),
    hasCurrentOrPastEvents() {
      return this.user.other_flags.has_events || Object.values(this.events).length > 0;
    },
    showCreatePastEventButtons() {
      if (!this.user.action_flags.has_read_event_guide) {
        return false;
      }

      return this.hasCurrentOrPastEvents;
    },
    hasCurrentEvents() {
      return Object.values(this.events).length > 0;
    }
  },
  data() {
    return { modalOpen: false };
  },
  mounted() {
    this.$store.dispatch("getMyEvents");
    this.$store.dispatch("getFestivals");
  },
  methods: {
    cardContainerClasses(i) {
      if (i % 3 === 0) {
        // first card
        return 'pr-0 md:pr-8';
      } else if (i % 3 === 1) {
        // second card
        return 'px-0 md:px-4  ';
      } else {
        // last card
        return 'pl-0 md:pl-8';
      }
    }
  }
}
</script>

<style scoped>

</style>